module.exports = {
      id: "financeLogo-usage",
      viewBox: "0 0 108 22",
      url: __webpack_public_path__ + "sprite.b16108e5f95a8323b5a812454e446fa5.svg#financeLogo-usage",
      toString: function () {
        return this.url;
      }
    }